import { getConfig } from "config";

const userAgentBlacklist = [
  /^;__CT_JOB_ID__:[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12};$/,
];

const config = {
  sentryDSN: "https://d4e2afa55a49471a9936b55aec915b09@sentry.io/179335",
  options: {
    environment: getConfig("env"),
    ignoreUrls: [
      /localhost/i,
      /ngrok\.io/i,

      // taken from https://gist.github.com/impressiver/5092952
      // Facebook
      /graph\.facebook\.com/i,
      /connect\.facebook\.net\/en_US\/all\.js/i,
      // Chrome extensions
      /extensions\//i,
      /^chrome:\/\//i,
    ],
    shouldSendCallback: (data: any) =>
      data.request &&
      data.request.headers &&
      data.request.headers["User-Agent"] &&
      !userAgentBlacklist.find(regex => data.request.headers["User-Agent"].match(regex)),
  },
};

export default config;
